<template>
  <div class="carousel-container">
    <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-inner">
        <div class="carousel-item " :class="index == 0 ? ' active ' : ''"
          v-for="(image, index) in screenWidth > 600 ? imagesDesktop : imagesMovil" :key="index">
          <img :src="getImageUrl(image)" class="" alt="...">
        </div>
      </div>
      <button class="carousel-control carousel-control-prev" type="button" data-bs-target="#carouselExampleControls"
        data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control carousel-control-next" type="button" data-bs-target="#carouselExampleControls"
        data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
    <div class="carousel-overlay-text animate__animated animate__fadeInUp">
      <p class="homeTitulo1">Calidad, Sustentabilidad y Confianza</p>
      <img src="../../../public/assets/images/home/linea.svg" class="img-line d-block mx-auto" alt="...">
      <p class="font32 homeTitulo2 mx-auto">Hacemos de cada proyecto una gran obra.</p>
      <div class="bb-1 w-fc mx-auto px-3">
        <p @click="() => $router.push('/terranova')" class="text-uppercase font16 mt-3">Ver proyecto</p>
      </div>
    </div>
  </div>
</template>

<script>
import { inject } from 'vue';

export default {
  name: 'ComponenteCarrousel',
  setup() {
    const screenWidth = inject('screenWidth');
    const getImageUrl = inject('getImageUrl');

    return {
      screenWidth,
      getImageUrl
    };
  }, data() {
    return {
      imagesDesktop: [
        "assets/images/home/Friax_Banner1.png",
        "assets/images/home/Friax_Banner2.png",
        "assets/images/home/Friax_Banner3.png",
      ],
      imagesMovil: [
        "assets/images/movil/home/Friax_Banner1.png",
        "assets/images/movil/home/Friax_Banner2.png",
        "assets/images/movil/home/Friax_Banner3.png",
      ],
    };
  },
}
</script>